import { request } from '@/shared/api/request'

export const getTradeUnionEmployeeList = () => {
	return request({ url: 'colcontract/tradeUnion/getByOrgContracts', method: 'GET' })
}
